module.exports = {"id":"213581","name":"Martín Nervo","rating":"74","photo":"./data/images/photos/2/213581.png","club":{"name":"Parque Patricios","logo":"./data/images/clubs/ParquePatricios.png"},"positions":["DC","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MartinNervo0.json
// module id = 2824
// module chunks = 0